import Vue from 'vue';

/*

    cols
    name_id
    state
    type
    network
    conf 配置
    ip_addr
    proj
    bill
    operate

    专属
    安全组
    容灾租
    DNS1
    DNS2


 */


export default {
    validDia: {
        veridStatus: false,
        mobile: '',
    },
    getProjList: [],
    RegionInfos: [],
    list: [],
    total: 0,
    LineSet: [],
    eipLineNameSet: {},
    productGroups: {},
    createProductSet: {},
    KecSystem: {},
    osImages: {},
    pTypeConfig: [],
    kecEbsSet: {},
    imageSet: {},
    eipSet: {},
    checkBwsConfigSet: {},
    bandwidthListSet: {},
    allVpcSet: {},
    adrListSet: {},
    NotAvailableIpAddress: {},
    SubnetSet: {},
    instancePrivateIpQuota: {},
    assignPrivateIpAddressData: {},
    UnAssignPrivateIpAddressData: {},
    kecPriceSet: {},
    eipPriceSet: {},
    dedicatePriceSysSet: {},
    DedicateListSet: {},
    tagKeySet: {},
    tagValueSet: {},
    avoidSet: {},
    avoidListSet: {},
    avoidPriceSet: {},
    judgeGameUser: {},
    createAvoidSet: {},
    RootSizeQuota: {},
    instanceByIds: {},

    handleSets: function (data) {
        // 套餐按cpu进行归并，并且升序排序
        var sets = {};
        _.each(data, function (item) {
            if (!sets[item.cpu]) {
                sets[item.cpu] = {};
            }
            var set = sets[item.cpu];
            var mems = item.memory && item.memory.split(',');
            _.each(mems, function (mem) {
                set[mem] = item;
            });
        });
        // 排序
        var sortSets = {};
        _.each(_.sortBy(_.keys(sets), function (item) {
            return item;
        }), function (item) {
            var sortMemSets = {};
            _.each(_.sortBy(_.keys(sets[item]), function (item) {
                return item;
            }), function (mem) {
                sortMemSets[mem] = sets[item][mem];
            });
            sortSets[item] = sortMemSets;
        });
        return sortSets;
    },
    checkTryOrder: 0,
    kecBill: {},
    eipBill: {},
    kecDiscount: 1,
    eipDiscount: 1,
    disCountObj: {},
    colsAll :[{
        name: Vue.$trans(`名称/ID`),
        id: 'nameId',
        disabled: true
    },{
        name: Vue.$trans(`镜像`),
        id: 'image',
        disabled: false
    },{
        name: Vue.$trans(`监控`),
        id: 'supervisory',
        disabled: false
    },{
        name: Vue.$trans(`类型`),
        id: 'type',
        disabled: false
    },{
        name: Vue.$trans(`状态`),
        id: 'state',
        disabled: false
    }, {
        name: Vue.$trans(`所属网络`),
        id: 'network',
        disabled: false
    }, {
        name: Vue.$trans(`套餐规格`),
        id: 'packageSpec',
        disabled: false
    }, {
        name: Vue.$trans(`配置`),
        id: 'config',
        disabled: false
    }, {
        name: Vue.$trans(`IPV4地址`),
        id: 'ipv4',
        disabled: false
    }, {
        name: Vue.$trans(`IPV6地址`),
        id: 'ipv6',
        disabled: false
    }, {
        name: Vue.$trans(`已绑定IAM角色`),
        id: 'iam',
        disabled: false
    }, {
        name: Vue.$trans(`所属项目`),
        id: 'project',
        disabled: false
    },{
        name: Vue.$trans(`计费方式`),
        id: 'charge',
        disabled: false
    },{
        name: Vue.$trans(`专属宿主机`),
        id: 'exclusive',
        disabled: false
    }, {
        name: Vue.$trans(`专属宿主机ID`),
        id: 'DedicatedUuid',
        disabled: false,
    // },{
    //     name: Vue.$trans(`可用区`),
    //     id: "az",
    //     disabled: false
    // },{
    //     name: Vue.$trans(`到期时间`),
    //     id: 'deadline',
    //     disabled: false
    // },{
    //     name: Vue.$trans(`创建时间`),
    //     id: 'create_time',
    //     disabled: false
    // },{
    //     name: 'VPC',
    //     id: 'vpc',
    //     disabled: false
    // },{
    //     name: Vue.$trans(`子网`),
    //     id: 'subnet',
    //     disabled: false
    },{
        name: Vue.$trans(`安全组（防火墙）`),
        id: 'firewall',
        disabled: false
    }, {
        name: Vue.$trans(`容灾组`),
        id: 'disaster',
        disabled: false
    },{
        name: 'DNS1',
        id: 'dns1',
        disabled: false
    },{
        name: 'DNS2',
        id: 'dns2',
        disabled: false
    },
    // {
    //     name: Vue.$trans(`业务组`),
    //     id: 'group',
    //     disabled: false
    // }, 
    {
        name: Vue.$trans(`标签`),
        id: 'tag',
        disabled: false
    }, {
        name: Vue.$trans(`资源保护`),
        id: 'protect',
        disabled: false
    }, {
        name: Vue.$trans(`启动模式`),
        id: 'imageMode',
        disabled: false
    }, {
        name: Vue.$trans(`操作`),
        id: 'operation',
        disabled: true
    }],
    //默认不展示的列
    defaultOmit: ['create', 'dns1', 'firewall', 'dns2', 'vpc', 'subnet', 'exclusive', 'DedicatedUuid', 'disaster', 'ipv6', 'protect', 'imageMode'],
    get cols() {
        return _.omitBy(this.colsAll, item => {
            return item.id == 'group'
        });
    },
    get basicCol() {
        let arr = [];
        _.forEach(this.colsAll, item => {
            if(_.indexOf(['exclusive', 'az', 'vpc', 'subnet', 'disaster', 'DedicatedUuid', 'dns1', 'dns2', 'project'], item.id) == -1) {
                arr.push(item);
            }
        });
        return arr;
    },
    set listChecked(value) {
        return value;
    },
    get listChecked() {
        let me = this, arr = [];
        let omit;
        try {
            omit = JSON.parse(localStorage.omitList) || this.defaultOmit;
        } catch(e) {
            omit = this.defaultOmit;
        }
        _.forEach(this.colsAll, item => {
            if(_.indexOf(omit, item.id) == -1) {
                arr.push(item.id);
            }
        });
        // console.log(omit, arr, 12312321);
        return arr;
    },
    set tagsChecked(value) {
        return value
    },
    get tagsChecked() {
        //展示的tags
        try {
            return JSON.parse(localStorage.tagsChecked) || [];
        } catch(e) {
            return [];
        }
    },
    KeySet: {},
    OverViewList: [],
    Totalkecnum: 0,
    Activenum: 0,
    Toexpirenum: 0,
    Expirednum: 0,
    Othernum: 0,
    CPUnum: 0,
    Memnum: 0,
    Imagenum: 0,
    Ebsnum: 0,
    Localdisknum: 0,
    SnapshotTotalCount: 0,
    SnapshotTotalSize: 0,
    SnapshotDailyIncremental: 0,
    DescribeUpdateInfos: [],
    AllRecentCreated: 0,
}
